export default __webpack_public_path__ + "static/media/enroll.5893049c.svg";